import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';

export class SubscriptionRequestModel {
    serviceOfferCodes: Array<any>;
    serviceStatus: string;

    constructor() {
        this.serviceOfferCodes = undefined;
        this.serviceStatus = undefined;
    }
}
